import dynamic from "next/dynamic";
import styleSub from "../../../styles/Subpage.module.scss";
import cellPlugins from "../../../components/plugins/cellPlugins";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { fetcher, staticPath } from "../../../utils";
import { useRouter } from "next/router";
import useSWR from "swr";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import DijiKolayPopup from "../../../components/popup/DijiKolayPopup";
import PageLayout from "../../../components/layout/PageLayout";

const Editor = dynamic(() => import("@react-page/editor"), {
  ssr: false,
});

const Seo = dynamic(() => import("../../../components/seo/Seo"), {
  ssr: false,
});

const SubTitle = dynamic(() => import("../../../components/title/SubTitle"), {
  ssr: false,
});

const Error = dynamic(() => import("../../../components/error/Error"), {
  ssr: false,
});

const Page = (props) => {
  const {
    pageName,
    pageRoute,
    data,
    errorCode,
    navbar,
    footer,
    navbarData,
    navbarFooterData,
  } = props;
  const { asPath, locale } = useRouter();
  const { t } = useTranslation();
  const [main, setMain] = useState();
  const [slug, setSlug] = useState();
  const { data: menu } = useSWR("menu", fetcher);
  const [descr, setDescr] = useState();
  const router = useRouter();
  useEffect(() => {
    if (router.query.slug === "teknolojik-altyapimiz") {
      setDescr(
        "İşNet'in Teknolojik Altyapımız hizmeti hakkında detaylı bilgi almak için sayfayı inceleyebilir ve başvuru için formu doldurabilirsiniz."
      );
    } else {
      setDescr(
        "Dijital dönüşüm dostu İşNet'in ${pageName} hizmeti hakkında bilgi almak için sayfamızı inceleyin. Daha fazla bilgi için başvuru formunu doldurarak İşNet'in ${pageName} hizmeti ile tanışın."
      );
    }
    const mainRoute = menu?.find(
      (item) => item.href === router.query.main
    )?.name;
    const slugRoute = menu?.find(
      (item) => item.href === router.query.slug
    )?.name;
    setMain(mainRoute);
    setSlug(slugRoute);
  }, [menu, router]);

  if (errorCode) {
    return (
      <Error
        statusCode={errorCode}
        notFoundSentence={t("home:not_found")}
        home={t("home:go_to_home")}
      />
    );
  }
  return (
    <PageLayout
      navbarData={navbarData}
      navbar={navbar}
      footer={footer}
      navbarFooterData={navbarFooterData}
    >
      <SubTitle
        className="section_header_page_blog"
        TitleText={pageName}
        pageName={pageName}
        pageRoute={pageRoute}
        mainPage={main}
        imgUrl={
          data.picture
            ? data.picture?.type + ";base64," + data.picture?.src
            : "/logo.svg"
        }
        home={t("home:title")}
      />
      <Seo
        title={`${pageName} | İşNet`}
        keywords={pageName}
        description={descr}
        url={locale === "tr" ? asPath : "/en" + asPath}
        img={
          data.picture
            ? data?.picture?.type + ";base64," + data?.picture?.src
            : "/logo.svg"
        }
        script={`gtag("event", "view_cart", {
          currency: "TRY",
          value: 7.77,
          items: [
            {
              item_id: "SKU_12345",
              item_name: "${data.title}",
              coupon: "SUMMER_FUN",
              index: 0,
              item_brand: "İşNet",
              item_category: "${main}",
              item_category2: "${slug}",
              location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
              price: 9.99,
              quantity: 1
            }
          ],
        })`}
      />
      <div className={styleSub.sub_page}>
        <Container>
          <Editor
            value={JSON.parse(data.content)}
            cellPlugins={cellPlugins}
            readOnly
          />
        </Container>
       
      </div>
    </PageLayout>
  );
};

export async function getServerSideProps(context) {
  let { main, slug } = context.query;

  const [data, navbarData, navbarFooterData, footerData] = await Promise.all([
    fetch(`${process.env.ISNETURL}/page/${main}/${slug}`).then((res) =>
      res.json()
    ),
    fetch(`${process.env.ISNETURL}/menu`).then((res) => res.json()),
    fetch(`${process.env.ISNETURL}/menu/footermenu`).then((res) => res.json()),
    fetch(`${process.env.API_URL}/footer`).then((res) => res.json()),
  ]);

  const navbarFilter =
    navbarData && navbarData?.filter((item) => item.isDeleted === false);

  let navbar, footer;
  if (navbarFilter || footerData) {
    const nav = staticPath(navbarFilter);
    navbar = nav;
    footer = footerData;
  }

  context.res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  return {
    props: {
      ...(await serverSideTranslations(context.locale, [
        "home",
        "forms",
        "preApplication",
      ])),
      pageName: data ? data.title : "Server Error",
      pageRoute: `/${main}/${slug}`,
      data: data ? data : null,
      navbar,
      footer,
      navbarData,
      navbarFooterData,
    },
  };
}

export default Page;
